const SHOW_ERROR = 'SHOW_KLARNA_ERROR';
const TOGGLE_SHIPPING = 'TOGGLE_SHIPPING';
const TOGGLE_SELECTED = 'TOGGLE_SELECTED';
const OBSERVE_MODAL = 'OBSERVE_MODAL';
const SET_READY = 'KLARNA_SET_READY';
const SET_KLARNA_ORDER = 'SET_KLARNA_ORDER';
const SET_KLARNA_EMD_ENABLED = 'SET_KLARNA_EMD_ENABLED';
const SET_INITIALIZING = 'KLARNA_SET_INITIALIZING';

export {
    SHOW_ERROR, TOGGLE_SHIPPING, TOGGLE_SELECTED, OBSERVE_MODAL, SET_READY, SET_KLARNA_ORDER, SET_KLARNA_EMD_ENABLED, SET_INITIALIZING
};
